import { billingExportPath } from './constants';
import { baseAutomationUrl } from 'src/config';
import { getAccessToken, getRealmName } from 'src/routes/AuthContext';
import { TBillingExportPullBody } from './types';
import axios from 'axios';
import { getClientIpHeader } from 'src/services/clientIpService/getClientIp';

/**
 * BOPS-440 / RA-2285 — the billing blockers a `/billing/pull` with the same body would download,
 * as a JSON array; `[]` means the facility is clear to pull. Read from the OLAP warehouse, so a
 * custom range's dates are accepted whatever the facility's export format. A 503 means the check
 * could not run — not that there is nothing blocking — so callers must not treat it as clear.
 */
export const getBillingBlockers = async (body: TBillingExportPullBody) => {
  const token = await getAccessToken();
  const realm = getRealmName() ?? '';
  const getFacilityUuid = localStorage.getItem('facilityId');

  if (getFacilityUuid && getFacilityUuid.length) {
    body.facility_uuid = getFacilityUuid;
  }

  body.enterprise_name = realm;
  body.batch_type = 'BILLING';

  const url = `${baseAutomationUrl}${billingExportPath.BILLING_BLOCKERS}`;

  return axios.post(url, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(await getClientIpHeader()),
    },
  });
};
